// frontend/packages/business-console/src/components/layout/MobileTopBar.jsx
//
// Slim top app bar shown only on mobile. Hosts the hamburger that opens
// the sidebar drawer, the brand mark for orientation, and the theme
// toggle. Logout is reachable from inside the drawer's footer (via
// Sidebar.jsx) so we don't double-up affordances on a small screen.

import React from "react";
import {
  AppBar,
  IconButton,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";

import { upryzzeColorGradient } from "../../config/styles";
import { useThemeMode } from "../../theme";

export default function MobileTopBar({ onOpenNav, topOffset = 0 }) {
  const { mode, toggleMode } = useThemeMode();

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        // `top` is pushed down by `topOffset` so the staff-mode banner
        // (rendered above) doesn't overlap the mobile AppBar.
        top: topOffset,
        bgcolor: "background.paper",
        color: "text.primary",
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <Toolbar variant="dense" sx={{ minHeight: 56 }}>
        <IconButton
          edge="start"
          color="inherit"
          onClick={onOpenNav}
          aria-label="Open navigation menu"
          sx={{ mr: 1 }}
        >
          <MenuIcon />
        </IconButton>
        <Typography
          sx={{
            fontWeight: 800,
            flex: 1,
            backgroundImage: upryzzeColorGradient,
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            color: "transparent",
          }}
        >
          UpRyzze Console
        </Typography>
        <Tooltip
          title={mode === "dark" ? "Switch to light mode" : "Switch to dark mode"}
        >
          <IconButton
            color="inherit"
            onClick={toggleMode}
            aria-label="Toggle theme"
          >
            {mode === "dark" ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
          </IconButton>
        </Tooltip>
      </Toolbar>
    </AppBar>
  );
}
